<template>
  <div>
    <px-input-number v-if="isEditing"
                     label="Dias"
                     required
                     dense
                     append-icon="mdi-check"
                     @click:append="onClickSave()"
                     class="required rounded-tag-small"
                     style="width: 100px"
                     v-model="diasLimite"/>
    <span v-else>
      {{ notificacao.diasLimite }}
      <v-btn icon @click="onClickEdit">
        <v-icon small>mdi-pencil</v-icon>
      </v-btn>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    notificacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isEditing: false,
      diasLimite: 0,
    };
  },
  methods: {
    onClickEdit() {
      this.isEditing = true;
    },
    onClickSave() {
      this.isEditing = false;
      this.$emit('change', this.diasLimite);
    },
  },
  created() {
    this.diasLimite = this.notificacao.diasLimite || 0;
  },
};
</script>
